import { KolumnaDoRaportu } from '../arkuszSpisu/kolumnaDoRaportu';

export class EdytujFiltrPorownywaniaDanychModel {
  nazwa: string;
  polaSpisu: Array<string> = [];
  pokaz: number;
  kolumny: Array<KolumnaFiltraPorownywaniaDanych>;
  id: string;
  idProjektu: string;
  polaSpisuId: Array<string> = [];
}

export class KolumnaFiltraPorownywaniaDanych {
  id: string;
  nazwa: string;
  czyWybrano: boolean;
}
